"use strict";
/**
 * @author Harut.Arakelyan on 3/15/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DeHeadMenuType;
(function (DeHeadMenuType) {
    DeHeadMenuType[DeHeadMenuType["EXPORT_PDF"] = 1] = "EXPORT_PDF";
    DeHeadMenuType[DeHeadMenuType["EXPORT_RTF"] = 2] = "EXPORT_RTF";
    DeHeadMenuType[DeHeadMenuType["EXPORT_EXCEL"] = 3] = "EXPORT_EXCEL";
    DeHeadMenuType[DeHeadMenuType["HELP_MANUAL"] = 4] = "HELP_MANUAL";
    DeHeadMenuType[DeHeadMenuType["HELP_ONLINE"] = 5] = "HELP_ONLINE";
})(DeHeadMenuType = exports.DeHeadMenuType || (exports.DeHeadMenuType = {}));
//# sourceMappingURL=de-head-menu-type.enum.js.map